module.exports = __webpack_public_path__ + "media/images/pc/icon-star-green-0dba7f8a874fe819b528fb577ad9fa68.png";